import './style.scss';

// HeroSmallAlt Component JavaScript

document.addEventListener('DOMContentLoaded', function() {
    const components = document.querySelectorAll('.booom-hero-small-alt');

    components.forEach(function(component) {
        // Add your JavaScript functionality here
    });
});
